import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';

import { useAccountDetailsContext } from './CreateAccountFormProvider';
import { Region } from './hooks/useCreateAccount';

export const RegionSection = () => {
  const { accountDetails, handleRegionChange } = useAccountDetailsContext();

  return (
    <>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Choose where your data is stored to comply with data regulations. This
        can&apos;t be changed later. If unsure, select EU.
      </Typography>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="region"
          name="region"
          value={accountDetails.region}
          onChange={(_e, region) => handleRegionChange(region as Region)}
        >
          <FormControlLabel
            value={Region.RegionEu}
            control={<Radio color="primary" />}
            label="EU"
          />
          <FormControlLabel
            value={Region.RegionUs}
            control={<Radio color="primary" />}
            label="US"
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};
